// @flow
import type { ActiveProductFilters } from 'types/filter';
import { ProductActionTypes } from './actionTypes';

const initialState = {
  products: [],
  productDetails: null,
  filters: null,
  activeFilters: null,
  loading: {
    products: false,
    productDetails: false,
  },
  error: {
    products: null,
    productDetails: false,
  },
};

const getInitialActiveFilterState = (): ActiveProductFilters => {
  return {
    location: [],
    propertyType: [],
    beds: undefined,
    area: [],
    projects: [],
  };
};

const toggleArrayItem = (value: number, arr: Array<number>): Array<number> => {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  } else {
    arr = arr.filter(item => item !== value);
  }

  return arr;
};

const updateActiveFilters = (
  payload: { type: string, value: number | Array<number> },
  filters: ActiveProductFilters
): ActiveProductFilters => {
  const newFilters = { ...filters };
  const value = payload.value;
  switch (payload.type) {
    case 'beds':
      newFilters.beds = value;
      break;
    case 'area':
      newFilters.area = value;
      break;
    case 'location':
      newFilters.location = toggleArrayItem(value, newFilters.location);
      break;
    case 'propertyType':
      newFilters.propertyType = toggleArrayItem(value, newFilters.propertyType);
      break;
    case 'project':
      newFilters.projects = toggleArrayItem(value, newFilters.projects);
      break;
    default:
      break;
  }

  return newFilters;
};

const ProductBrowserReducer = (state = initialState, action) => {
  const { type, payload, error } = action;
  switch (type) {
    case ProductActionTypes.PRODUCT_BROWSER.FETCH:
      return {
        ...state,
        loading: { ...state.loading, products: true },
        error: { ...state.error, products: null },
      };
    case ProductActionTypes.PRODUCT_BROWSER.SUCCESS:
      return {
        ...state,
        products: payload,
        loading: { ...state.loading, products: false },
      };
    case ProductActionTypes.PRODUCT_BROWSER.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, products: false },
        error: { ...state.error, products: error },
      };
    // Project filters
    case ProductActionTypes.PRODUCT_FILTERS.INITIALIZE:
      return {
        ...state,
        filters: payload,
        activeFilters: Object.assign({}, getInitialActiveFilterState()),
      };
    case ProductActionTypes.PRODUCT_FILTERS.TOGGLE_FILTER:
      const activeFilters = updateActiveFilters(payload, state.activeFilters);
      return {
        ...state,
        activeFilters: { ...activeFilters },
      };
    case ProductActionTypes.PRODUCT_FILTERS.CLEAR_FILTERS:
      return {
        ...state,
        activeFilters: Object.assign({}, getInitialActiveFilterState()),
      };
    case ProductActionTypes.PRODUCT_DETAILS.FETCH:
      return {
        ...state,
        loading: { ...state.loading, productDetails: true },
        error: { ...state.error, productDetails: null },
      };
    case ProductActionTypes.PRODUCT_DETAILS.SUCCESS:
      return {
        ...state,
        productDetails: payload,
        loading: { ...state.loading, productDetails: false },
      };
    case ProductActionTypes.PRODUCT_DETAILS.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, productDetails: false },
        error: { ...state.error, productDetails: payload },
      };
    default:
      return state;
  }
};

export default ProductBrowserReducer;
